import type { Locale } from 'utils/intlUtils';

import { storageManager, StorageType } from 'utils/storageUtils';

export const localeStorage = storageManager.createOrFetchStorage<Locale>('locale');

export const timeZoneStorage = storageManager.createOrFetchStorage<string>('timeZone');

/**
 * Flags that the locale was set via a `?lang` query param for this session.
 */
export const localeQueryOverrideStorage = storageManager.createOrFetchStorage<boolean>(
  'localeQueryOverride',
  StorageType.SESSION
);
